import React from 'react'
import { useTranslation } from 'react-i18next'
import IconSelect, { IconSelectProps } from '@node-space/storybook-components/dist/IconSelect'
import { Box } from '@node-space/ui-components'
import { InputLabelTooltip } from 'components/Text/InputLabelTooltip'

export interface CurrencyInputProps {
  currencyField: IconSelectProps
}

export const CurrencyInput = ({ currencyField }: CurrencyInputProps) => {
  const { t } = useTranslation()

  return (
    <Box>
      <InputLabelTooltip
        id={currencyField?.name}
        labelText={currencyField?.label}
        tooltipHeader={t('businessActivity.currencyTooltip.title')}
        tooltipText={t('businessActivity.currencyTooltip.yourBusiness')}
      />
      <IconSelect
        {...currencyField}
        iconsUrl={process.env.ICONS_URL}
        label=""
        isSearchable
        testid="currency-select"
      />
    </Box>
  )
}
